module.exports = __webpack_public_path__ + "img/logo-nrel-bw.0215c8c6.png";